var exports = {
  "kL": "xa15a2ab7--7f5a29--container",
  "wx": "xa15a2ab7--7f5a29--header",
  "j0": "xa15a2ab7--7f5a29--header-information",
};

module.exports = exports;
